<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">{{ $t('reportparts.title') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div id="accordion">
            <div class="card mb-1">
              <div class="card-header" id="headingOne">
                <h4 class="mb-0">
                  {{ $t('reportparts.search') }}
                  <a
                    class="text-inherit"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                    href=""
                  >
                    <i class="icon-arrow-down"></i>
                  </a>
                </h4>
              </div>
              <div class="collapse show" id="collapseOne" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body border-top">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-row align-items-center">
                        <div class="col-auto">
                          <label class="sr-only" for="filter_code">{{ $t('reportparts.part-code') }}</label>
                          <input
                            class="form-control mb-2"
                            id="filter_code"
                            type="text"
                            :placeholder="$t('reportparts.part-code')"
                            v-model="filter_code"
                          >
                        </div>
                        <div class="col-auto">
                          <label class="sr-only" for="filter_name">{{ $t('reportparts.part-name') }}</label>
                          <input
                            class="form-control mb-2"
                            id="filter_name"
                            type="text"
                            :placeholder="$t('reportparts.part-name')"
                            v-model="filter_name"
                          >
                        </div>
                        <div class="col-auto">
                          <label class="sr-only" for="filter_start">{{ $t('reportparts.tender-start') }}</label>
                          <datetime
                            :phrases="{ok: 'Continue', cancel: 'Exit'}"
                            :week-start="1"
                            auto
                            format="dd.MM.yyyy"
                            id="filter_start"
                            input-class="form-control mb-2"
                            :placeholder="$t('reportparts.tender-start')"
                            type="date"
                            value-zone="local"
                            v-model="filter_start"
                          ></datetime>
                        </div>
                        <div class="col-auto">
                          <label class="sr-only" for="filter_finish">{{ $t('reportparts.finish') }}</label>
                          <datetime
                            :phrases="{ok: 'Continue', cancel: 'Exit'}"
                            :week-start="1"
                            auto
                            format="dd.MM.yyyy"
                            id="filter_finish"
                            input-class="form-control mb-2"
                            :placeholder="$t('reportparts.finish')"
                            type="date"
                            value-zone="local"
                            v-model="filter_finish"
                          ></datetime>
                        </div>
                        <div class="col-auto">
                          <label class="sr-only" for="filter_reason">{{ $t('reportparts.reason') }}</label>
                          <select
                              class="chosen-select form-control mb-2"
                              id="filter_reason"
                              v-model="filter_reason"
                          >
                            <option value="">-- {{ $t('reportparts.all-statuses') }}--</option>
                            <option value="PRICE">{{ $t('reportparts.price') }}</option>
                            <option value="DUE DATE">{{ $t('reportparts.due-date') }}</option>
                            <option value="PRODUCER">{{ $t('reportparts.producer') }}</option>
                            <option value="TEST">{{ $t('reportparts.test') }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-row align-items-center">
                        <datefilters ref="datefilters" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-row align-items-center">
                        <div class="col-auto">
                          <button class="btn btn-success mb-2" type="submit" @click="filter">{{ $t('reportparts.search-btn') }}</button>
                          <button class="btn btn-outline-info mb-2" type="cancel" @click="clear_filters">{{ $t('reportparts.cancel') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper table-responsive container-fluid dt-bootstrap4 no-footer">
                <datatablebuttons/>
                <search @make_search="make_search"/>
                <table class="table table-striped dataTable my-4 w-100" id="parts">
                  <thead>
                    <tr>
                      <th>
                        <div class="checkbox c-checkbox">
                          <label class="mb-0 p">
                            <input class="select-box" type="checkbox" v-model="selectAll">
                            <span class="fa fa-check"></span>
                          </label>
                        </div>
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'code',
                          'sorting_desc': ordering === '-code'}"
                        @click="order('code')">{{ $t('reportparts.part-code') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'name',
                          'sorting_desc': ordering === '-name'}"
                        @click="order('name')">{{ $t('reportparts.part-name') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'tender_code',
                          'sorting_desc': ordering === '-tender_code'}"
                        @click="order('tender_code')">{{ $t('reportparts.tender') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'period',
                          'sorting_desc': ordering === '-period'}"
                        @click="order('period')">{{ $t('reportparts.period') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'min_price',
                          'sorting_desc': ordering === '-min_price'}"
                        @click="order('min_price')">{{ $t('reportparts.min-price') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'max_price',
                          'sorting_desc': ordering === '-max_price'}"
                        @click="order('max_price')">{{ $t('reportparts.max-price') }}
                      </th>
                      <th
                          :class="{
                          'sorting_asc': ordering === 'prices',
                          'sorting_desc': ordering === '-prices'}"
                          @click="order('prices')">{{ $t('reportparts.prices') }}
                      </th>
                      <th
                          :class="{
                          'sorting_asc': ordering === 'reasons',
                          'sorting_desc': ordering === '-reasons'}"
                          @click="order('reasons')">{{ $t('reportparts.reasons') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="row.id" class="gradeX" v-for="row in rows">
                      <td>
                        <div class="checkbox c-checkbox">
                          <label class="mb-0">
                            <input :value="row.id" class="select-box" type="checkbox" v-model="selected">
                            <span class="fa fa-check"></span>
                          </label>
                        </div>
                      </td>
                      <td>
                          {{ row.code }}
                      </td>
                      <td>{{ row.name }}</td>
                      <td>
                        <router-link
                          v-if="row.tender && row.tender_status==='DRAFT'"
                          :to="{name: 'tender_edit', params: {id: row.tender}}"
                          target="_blank">
                          {{ row.tender_code }}
                        </router-link>
                        <router-link
                          v-else-if="row.tender"
                          :to="{name: 'tender_view', params: {id: row.tender}}"
                          target="_blank">
                          {{ row.tender_code }}
                        </router-link>
                        <span v-else>{{ row.tender_code }}</span>
                      </td>
                      <td>{{ row.period }}</td>
                      <td>{{ Number(row.min_price).toFixed(4).replace(/0{0,2}$/, '') }}</td>
                      <td>{{ Number(row.max_price).toFixed(4).replace(/0{0,2}$/, '') }}</td>
                      <td>{{ Number(row.prices).toFixed(4).replace(/0{0,2}$/, '') }}</td>
                      <td>{{ get_reason_names(row.reasons) }}</td>
                    </tr>
                  </tbody>
                </table>
                <pagination
                  :page="page"
                  :pages="pages"
                  :count="count"
                  :from="(page - 1) * page_size + 1"
                  :to="(page - 1) * page_size + rows.length"
                  @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import Datatablebuttons from '@/components/Datatablebuttons.vue'
import Datefilters from '@/components/Datefilters'
import { Datetime } from 'vue-datetime'
import Pagination from '@/components/Pagination.vue'
import Search from '@/components/Search.vue'
import XLSX from 'xlsx'
import app from '../main'

function calculateData(data) {
  let rowsData = []
  let rows = data

  rows.forEach(row => {
    rowsData.push({
      0: row.id,
      1: row.code,
      2: row.name,
      3: row.tender_code,
      4: row.period,
      5: row.min_price,
      6: row.max_price,
      7: row.prices,
      8: row.reasons
    })
  })
  return rowsData
}


const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || 'code'
  const page = parseInt(route.query.page) || 1

  let stored_filters = JSON.parse(
      localStorage.getItem('etend.filters.' + route.name)
  ) || {}

  const filterReason = route.query.filter_reason
      ||  stored_filters.filter_reason
      || ''
  const filterCode = route.query.filter_code
      || stored_filters.filter_code
  const filterName = route.query.filter_name
      || stored_filters.filter_name
  const filterStart = route.query.filter_start
      || stored_filters.filter_start
      || moment().startOf('month').toISOString()
  const filterFinish = route.query.filter_finish
      || stored_filters.filter_finish
      || null
  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
      || {}
  let page_size = route.query.page_size
      || stored_page_size[route.name]
      || process.env.DEFAULT_PAGE_SIZE

  api.get('/reports/parts/?page_size=50', {
    params: {
      search: search,
      ordering: ordering,
      page: page,
      page_size: page_size,
      filter_code: filterCode,
      filter_name: filterName,
      filter_start: filterStart,
      filter_finish: filterFinish,
      filter_reason: filterReason
    }
  })
    .then(resp => {
      next({
        rows: resp.data.results,
        rowsData: calculateData(resp.data.results),
        search: search,
        ordering: ordering,
        pages: resp.data.pages,
        count: resp.data.count,
        page: page,
        page_size: page_size,
        filter_code: filterCode,
        filter_name: filterName,
        filter_start: filterStart,
        filter_finish: filterFinish,
        filter_reason: filterReason
      })
    })
}

export default {
  components: {
    datatablebuttons: Datatablebuttons,
    datefilters: Datefilters,
    datetime: Datetime,
    pagination: Pagination,
    search: Search
  },
  data () {
    return {
      rows: [],
      rowsData: [],
      filter_reason: '',
      filter_code: null,
      filter_name: null,
      filter_start: null,
      filter_finish: null,
      search: null,
      ordering: 'code',
      pages: null,
      page_size: null,
      count: null,
      page: null,
      selected: [],
      columns: [
        this.$i18n.t('reportparts.part-code'),
        this.$i18n.t('reportparts.part-name'),
        this.$i18n.t('reportparts.tender'),
        this.$i18n.t('reportparts.period'),
        this.$i18n.t('reportparts.min-price'),
        this.$i18n.t('reportparts.max-price'),
        this.$i18n.t('reportparts.prices'),
        this.$i18n.t('reportparts.reasons'),
      ]
    }
  },
  mounted () {
    this.$parent.menu = 'reports'
    this.$parent.submenu = 'parts'
    this.$i18n.locale = this.$store.getters.language
    let stored_filters = JSON.parse(
        localStorage.getItem('etend.filters.' + this.$route.name)
    )
    if (stored_filters) {
      this.$refs.datefilters.selected = stored_filters.datefilters_selection
      this.filter_groups = stored_filters.filter_groups
    }
  },
  methods: {
    export_selected_rows() {
      let copyJson = []
      return Promise.all([
        api.get('/reports/parts/', {
          params: {
            ids: this.selected.join(','),
            page_size: 0,
            search: this.search,
            ordering: this.ordering,
            filter_code: this.filter_code,
            filter_name: this.filter_name,
            filter_start: this.filter_start,
            filter_finish: this.filter_finish,
            filter_reason: this.filter_reason
          }
        }).then(resp => {
          let rowsData = calculateData(resp.data)
          rowsData.forEach(row => {
            let rowJson = {}
            let i = 1
            this.columns.forEach(col => {
              rowJson[col] = row[i]
              i += 1
            })
            copyJson.push(rowJson)
          })
          let dataWS = XLSX.utils.json_to_sheet(copyJson)
          let wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS, 'data')
          XLSX.writeFile(wb, 'export.xlsx')
        })
      ])
    },
    export_all_rows() {
      let copyJson = []
      return Promise.all([
        api.get('/reports/parts/', {
          params: {
            page_size: 0,
            search: this.search,
            ordering: this.ordering,
            filter_code: this.filter_code,
            filter_name: this.filter_name,
            filter_start: this.filter_start,
            filter_finish: this.filter_finish,
            filter_reason: this.filter_reason
          }
        }).then(resp => {
          let rowsData = calculateData(resp.data)
          rowsData.forEach(row => {
            let rowJson = {}
            let i = 1
            this.columns.forEach(col => {
              rowJson[col] = row[i]
              i += 1
            })
            copyJson.push(rowJson)
          })
          let dataWS = XLSX.utils.json_to_sheet(copyJson)
          let wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS, 'data')
          XLSX.writeFile(wb, 'export.xlsx')
        })
      ])
    },
    get_reason_names(reasons){
      return reasons
          .replace('PRICE', this.$i18n.t('reportparts.price'))
          .replace('DUE DATE', this.$i18n.t('reportparts.due-date'))
          .replace('PRODUCER', this.$i18n.t('reportparts.producer'))
          .replace('TEST', this.$i18n.t('reportparts.test'))
    },
    order (o) {
      this.$router.push({
        query: {
          search: this.search,
          ordering: o === this.ordering ? '-' + o : o,
          page: 1,
          page_size: this.page_size,
          filter_code: this.filter_code,
          filter_name: this.filter_name,
          filter_start: this.filter_start,
          filter_finish: this.filter_finish,
          filter_reason: this.filter_reason
        }
      })
    },
    paginate (p) {
      this.$router.push({
        query: {
          page: p.page,
          page_size: p.page_size,
          search: this.search,
          ordering: this.ordering,
          filter_code: this.filter_code,
          filter_name: this.filter_name,
          filter_start: this.filter_start,
          filter_finish: this.filter_finish,
          filter_reason: this.filter_reason
        }
      })
    },
    make_search () {
      this.$parent.make_search(this.search, this.ordering)
    },
    filter () {
      let filters = {
        search: this.search,
        ordering: this.ordering,
        page: 1,
        filter_code: this.filter_code,
        filter_name: this.filter_name,
        filter_start: this.filter_start,
        filter_finish: this.filter_finish,
        filter_reason: this.filter_reason
      }
      this.$store.dispatch('setFilters', {
        datefilters_selection: this.$refs.datefilters.selected,
        name: this.$route.name,
        ...filters
      })

      app.$Progress.start()
      api.get('/reports/parts/', {
        params: {...filters, page_size: this.page_size}
      })
        .then(resp => {
          app.$Progress.finish()

          this.rows = resp.data.results
          this.rowsData = []
          this.rows.forEach(row => {
            this.rowsData.push({
              0: row.id,
              1: row.code,
              2: row.name,
              3: row.tender_code,
              4: row.period,
              5: row.min_price,
              6: row.max_price,
              7: row.prices,
              8: row.reasons
            })
          })
          this.pages = resp.data.pages
          this.count = resp.data.count
          this.page = 1
        })
      this.$router.push({
        query:{
          search: this.search,
          ordering: this.ordering,
          page: 1,
          page_size: this.page_size,
          filter_code: this.filter_code,
          filter_name: this.filter_name,
          filter_start: this.filter_start,
          filter_finish: this.filter_finish,
          filter_reason: this.filter_reason
        }
      })
    },
    clear_filters () {
      this.filter_code = null
      this.filter_name = null
      this.filter_start = null
      this.filter_finish = null
      this.filter_reason = ''
      this.$refs.datefilters.selected = null

      this.$store.dispatch('clearFilters', this.$route.name)

      app.$Progress.start()
      api.get('/reports/parts/', {
        params: {
          search: this.search,
          ordering: this.ordering,
          page: 1,
          page_size: this.page_size,
          filter_code: this.filter_code,
          filter_name: this.filter_name,
          filter_start: this.filter_start,
          filter_finish: this.filter_finish,
          filter_reason: this.filter_reason
        }
      })
        .then(resp => {
          app.$Progress.finish()

          this.rows = resp.data.results
          this.rowsData = []
          this.rows.forEach(row => {
            this.rowsData.push({
              0: row.id,
              1: row.code,
              2: row.name,
              3: row.tender_code,
              4: row.period,
              5: row.min_price,
              6: row.max_price,
              7: row.prices,
              8: row.reasons
            })
          })
          this.pages = resp.data.pages
          this.count = resp.data.count
          this.page = 1
        })
      this.$router.push({name: 'report_parts'}).catch(()=>{})
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    },
    selectAll: {
      get: function () {
        return this.rows ? this.selected.length === this.rows.length : false
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.rows.forEach(function (p) {
            selected.push(p.id)
          })
        }
        this.selected = selected
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Reportparts.vue